import { type ApiErrorEventDetail, categorizeApiError } from '@/shared/types/api';

export type { ApiErrorType, ApiErrorEventDetail } from '@/shared/types/api';
export { categorizeApiError } from '@/shared/types/api';

declare global {
  interface WindowEventMap {
    'api:error': CustomEvent<ApiErrorEventDetail>;
  }
}

export function dispatchApiError(detail: ApiErrorEventDetail): void {
  window.dispatchEvent(new CustomEvent('api:error', { detail }));
}

// Suppress unused import warning — categorizeApiError is re-exported
void categorizeApiError;
